import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { generateQueryKey } from '../../../../utils/generate-query-key';
import { browsingDomainStore } from '../../store';
export const getFilmAvailability = (filmId, siteId) => {
    const queryKey = generateQueryKey({ filmId, siteId });
    return getFetchedDataPayload(browsingDomainStore.data.filmAvailabilitiesByQuery[queryKey]);
};
